// QueryRequestProvider.tsx
import {FC, createContext, useContext, useState} from 'react'
import {
  initialQueryRequest,
  QueryRequestContextProps,
  QueryState,
  WithChildren,
} from 'src/_metronic/helpers'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

// Define default sorting state
const defaultQueryState: QueryState = {
  ...initialQueryRequest.state,
  sort: 'created_at', // Default column to sort
  order: 'desc', // Default order (descending)
};

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<QueryState>(defaultQueryState)

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}